module.exports = __webpack_public_path__ + "assets/img/btn-view-c0e53c8b.png";